import { createContext } from 'react';

// eslint-disable-next-line import/prefer-default-export
export const UserContext = createContext({
  loggedIn: false,
  isAdmin: false,
  language: 'pl',
});
